export default __webpack_public_path__ + "static/media/circle.32b7302c.png";